export const countryPhoneCodes = [
    {
      "name": "Afghanistan",
      "dial_code": "+93",
      "code": "AF",
      "flag": "🇦🇫",
      "currency_symbol": "؋"
    },
    {
      "name": "Aland Islands",
      "dial_code": "+358",
      "code": "AX",
      "flag": "🇦🇽",
      "currency_symbol": "€"
    },
    {
      "name": "Albania",
      "dial_code": "+355",
      "code": "AL",
      "flag": "🇦🇱",
      "currency_symbol": "L"
    },
    {
      "name": "Algeria",
      "dial_code": "+213",
      "code": "DZ",
      "flag": "🇩🇿",
      "currency_symbol": "د.ج"
    },
    {
      "name": "AmericanSamoa",
      "dial_code": "+1684",
      "code": "AS",
      "flag": "🇦🇸",
      "currency_symbol": "$"
    },
    {
      "name": "Andorra",
      "dial_code": "+376",
      "code": "AD",
      "flag": "🇦🇩",
      "currency_symbol": "€"
    },
    {
      "name": "Angola",
      "dial_code": "+244",
      "code": "AO",
      "flag": "🇦🇴",
      "currency_symbol": "Kz"
    },
    {
      "name": "Anguilla",
      "dial_code": "+1264",
      "code": "AI",
      "flag": "🇦🇮",
      "currency_symbol": "$"
    },
    {
      "name": "Antarctica",
      "dial_code": "+672",
      "code": "AQ",
      "flag": "🇦🇶",
      "currency_symbol": ""
    },
    {
      "name": "Antigua and Barbuda",
      "dial_code": "+1268",
      "code": "AG",
      "flag": "🇦🇬",
      "currency_symbol": "$"
    },
    {
      "name": "Argentina",
      "dial_code": "+54",
      "code": "AR",
      "flag": "🇦🇷",
      "currency_symbol": "$"
    },
    {
      "name": "Armenia",
      "dial_code": "+374",
      "code": "AM",
      "flag": "🇦🇲",
      "currency_symbol": "֏"
    },
    {
      "name": "Aruba",
      "dial_code": "+297",
      "code": "AW",
      "flag": "🇦🇼",
      "currency_symbol": "ƒ"
    },
    {
      "name": "Australia",
      "dial_code": "+61",
      "code": "AU",
      "flag": "🇦🇺",
      "currency_symbol": "$"
    },
    {
      "name": "Austria",
      "dial_code": "+43",
      "code": "AT",
      "flag": "🇦🇹",
      "currency_symbol": "€"
    },
    {
      "name": "Azerbaijan",
      "dial_code": "+994",
      "code": "AZ",
      "flag": "🇦🇿",
      "currency_symbol": "₼"
    },
    {
      "name": "Bahamas",
      "dial_code": "+1242",
      "code": "BS",
      "flag": "🇧🇸",
      "currency_symbol": "$"
    },
    {
      "name": "Bahrain",
      "dial_code": "+973",
      "code": "BH",
      "flag": "🇧🇭",
      "currency_symbol": ".د.ب"
    },
    {
      "name": "Bangladesh",
      "dial_code": "+880",
      "code": "BD",
      "flag": "🇧🇩",
      "currency_symbol": "৳"
    },
    {
      "name": "Barbados",
      "dial_code": "+1246",
      "code": "BB",
      "flag": "🇧🇧",
      "currency_symbol": "$"
    },
    {
      "name": "Belarus",
      "dial_code": "+375",
      "code": "BY",
      "flag": "🇧🇾",
      "currency_symbol": ""
    },
    {
      "name": "Belgium",
      "dial_code": "+32",
      "code": "BE",
      "flag": "🇧🇪",
      "currency_symbol": "€"
    },
    {
      "name": "Belize",
      "dial_code": "+501",
      "code": "BZ",
      "flag": "🇧🇿",
      "currency_symbol": "$"
    },
    {
      "name": "Benin",
      "dial_code": "+229",
      "code": "BJ",
      "flag": "🇧🇯",
      "currency_symbol": "Fr"
    },
    {
      "name": "Bermuda",
      "dial_code": "+1441",
      "code": "BM",
      "flag": "🇧🇲",
      "currency_symbol": "$"
    },
    {
      "name": "Bhutan",
      "dial_code": "+975",
      "code": "BT",
      "flag": "🇧🇹",
      "currency_symbol": "Nu."
    },
    {
      "name": "Bolivia, Plurinational State of",
      "dial_code": "+591",
      "code": "BO",
      "flag": "🇧🇴",
      "currency_symbol": "Bs."
    },
    {
      "name": "Bosnia and Herzegovina",
      "dial_code": "+387",
      "code": "BA",
      "flag": "🇧🇦",
      "currency_symbol": ""
    },
    {
      "name": "Botswana",
      "dial_code": "+267",
      "code": "BW",
      "flag": "🇧🇼",
      "currency_symbol": "P"
    },
    {
      "name": "Brazil",
      "dial_code": "+55",
      "code": "BR",
      "flag": "🇧🇷",
      "currency_symbol": "R$"
    },
    {
      "name": "British Indian Ocean Territory",
      "dial_code": "+246",
      "code": "IO",
      "flag": "🇮🇴",
      "currency_symbol": "$"
    },
    {
      "name": "Brunei Darussalam",
      "dial_code": "+673",
      "code": "BN",
      "flag": "🇧🇳",
      "currency_symbol": "$"
    },
    {
      "name": "Bulgaria",
      "dial_code": "+359",
      "code": "BG",
      "flag": "🇧🇬",
      "currency_symbol": "лв"
    },
    {
      "name": "Burkina Faso",
      "dial_code": "+226",
      "code": "BF",
      "flag": "🇧🇫",
      "currency_symbol": "Fr"
    },
    {
      "name": "Burundi",
      "dial_code": "+257",
      "code": "BI",
      "flag": "🇧🇮",
      "currency_symbol": "Fr"
    },
    {
      "name": "Cambodia",
      "dial_code": "+855",
      "code": "KH",
      "flag": "🇰🇭",
      "currency_symbol": "៛"
    },
    {
      "name": "Cameroon",
      "dial_code": "+237",
      "code": "CM",
      "flag": "🇨🇲",
      "currency_symbol": "Fr"
    },
    {
      "name": "Canada",
      "dial_code": "+1",
      "code": "CA",
      "flag": "🇨🇦",
      "currency_symbol": "$"
    },
    {
      "name": "Cape Verde",
      "dial_code": "+238",
      "code": "CV",
      "flag": "🇨🇻",
      "currency_symbol": "Esc"
    },
    {
      "name": "Cayman Islands",
      "dial_code": "+ 345",
      "code": "KY",
      "flag": "🇰🇾",
      "currency_symbol": "$"
    },
    {
      "name": "Central African Republic",
      "dial_code": "+236",
      "code": "CF",
      "flag": "🇨🇫",
      "currency_symbol": "Fr"
    },
    {
      "name": "Chad",
      "dial_code": "+235",
      "code": "TD",
      "flag": "🇹🇩",
      "currency_symbol": "Fr"
    },
    {
      "name": "Chile",
      "dial_code": "+56",
      "code": "CL",
      "flag": "🇨🇱",
      "currency_symbol": "$"
    },
    {
      "name": "China",
      "dial_code": "+86",
      "code": "CN",
      "flag": "🇨🇳",
      "currency_symbol": "¥"
    },
    {
      "name": "Christmas Island",
      "dial_code": "+61",
      "code": "CX",
      "flag": "🇨🇽",
      "currency_symbol": "$"
    },
    {
      "name": "Cocos (Keeling) Islands",
      "dial_code": "+61",
      "code": "CC",
      "flag": "🇨🇨",
      "currency_symbol": "$"
    },
    {
      "name": "Colombia",
      "dial_code": "+57",
      "code": "CO",
      "flag": "🇨🇴",
      "currency_symbol": "$"
    },
    {
      "name": "Comoros",
      "dial_code": "+269",
      "code": "KM",
      "flag": "🇰🇲",
      "currency_symbol": "Fr"
    },
    {
      "name": "Congo",
      "dial_code": "+242",
      "code": "CG",
      "flag": "🇨🇬",
      "currency_symbol": "Fr"
    },
    {
      "name": "Congo, The Democratic Republic of the Congo",
      "dial_code": "+243",
      "code": "CD",
      "flag": "🇨🇩",
      "currency_symbol": "FC"
    },
    {
      "name": "Cook Islands",
      "dial_code": "+682",
      "code": "CK",
      "flag": "🇨🇰",
      "currency_symbol": "$"
    },
    {
      "name": "Costa Rica",
      "dial_code": "+506",
      "code": "CR",
      "flag": "🇨🇷",
      "currency_symbol": "₡"
    },
    {
      "name": "Cote d'Ivoire",
      "dial_code": "+225",
      "code": "CI",
      "flag": "🇨🇮",
      "currency_symbol": "Fr"
    },
    {
      "name": "Croatia",
      "dial_code": "+385",
      "code": "HR",
      "flag": "🇭🇷",
      "currency_symbol": "€"
    },
    {
      "name": "Cuba",
      "dial_code": "+53",
      "code": "CU",
      "flag": "🇨🇺",
      "currency_symbol": "$"
    },
    {
      "name": "Cyprus",
      "dial_code": "+357",
      "code": "CY",
      "flag": "🇨🇾",
      "currency_symbol": "€"
    },
    {
      "name": "Czech Republic",
      "dial_code": "+420",
      "code": "CZ",
      "flag": "🇨🇿",
      "currency_symbol": "Kč"
    },
    {
      "name": "Denmark",
      "dial_code": "+45",
      "code": "DK",
      "flag": "🇩🇰",
      "currency_symbol": "kr"
    },
    {
      "name": "Djibouti",
      "dial_code": "+253",
      "code": "DJ",
      "flag": "🇩🇯",
      "currency_symbol": "Fr"
    },
    {
      "name": "Dominica",
      "dial_code": "+1767",
      "code": "DM",
      "flag": "🇩🇲",
      "currency_symbol": "$"
    },
    {
      "name": "Dominican Republic",
      "dial_code": "+1849",
      "code": "DO",
      "flag": "🇩🇴",
      "currency_symbol": "$"
    },
    {
      "name": "Ecuador",
      "dial_code": "+593",
      "code": "EC",
      "flag": "🇪🇨",
      "currency_symbol": "$"
    },
    {
      "name": "Egypt",
      "dial_code": "+20",
      "code": "EG",
      "flag": "🇪🇬",
      "currency_symbol": "£"
    },
    {
      "name": "El Salvador",
      "dial_code": "+503",
      "code": "SV",
      "flag": "🇸🇻",
      "currency_symbol": "$"
    },
    {
      "name": "Equatorial Guinea",
      "dial_code": "+240",
      "code": "GQ",
      "flag": "🇬🇶",
      "currency_symbol": "Fr"
    },
    {
      "name": "Eritrea",
      "dial_code": "+291",
      "code": "ER",
      "flag": "🇪🇷",
      "currency_symbol": "Nfk"
    },
    {
      "name": "Estonia",
      "dial_code": "+372",
      "code": "EE",
      "flag": "🇪🇪",
      "currency_symbol": "€"
    },
    {
      "name": "Ethiopia",
      "dial_code": "+251",
      "code": "ET",
      "flag": "🇪🇹",
      "currency_symbol": "Br"
    },
    {
      "name": "Falkland Islands (Malvinas)",
      "dial_code": "+500",
      "code": "FK",
      "flag": "🇫🇰",
      "currency_symbol": "£"
    },
    {
      "name": "Faroe Islands",
      "dial_code": "+298",
      "code": "FO",
      "flag": "🇫🇴",
      "currency_symbol": "kr"
    },
    {
      "name": "Fiji",
      "dial_code": "+679",
      "code": "FJ",
      "flag": "🇫🇯",
      "currency_symbol": "$"
    },
    {
      "name": "Finland",
      "dial_code": "+358",
      "code": "FI",
      "flag": "🇫🇮",
      "currency_symbol": "€"
    },
    {
      "name": "France",
      "dial_code": "+33",
      "code": "FR",
      "flag": "🇫🇷",
      "currency_symbol": "€"
    },
    {
      "name": "French Guiana",
      "dial_code": "+594",
      "code": "GF",
      "flag": "🇬🇫",
      "currency_symbol": "€"
    },
    {
      "name": "French Polynesia",
      "dial_code": "+689",
      "code": "PF",
      "flag": "🇵🇫",
      "currency_symbol": "₣"
    },
    {
      "name": "Gabon",
      "dial_code": "+241",
      "code": "GA",
      "flag": "🇬🇦",
      "currency_symbol": "Fr"
    },
    {
      "name": "Gambia",
      "dial_code": "+220",
      "code": "GM",
      "flag": "🇬🇲",
      "currency_symbol": "D"
    },
    {
      "name": "Georgia",
      "dial_code": "+995",
      "code": "GE",
      "flag": "🇬🇪",
      "currency_symbol": "₾"
    },
    {
      "name": "Germany",
      "dial_code": "+49",
      "code": "DE",
      "flag": "🇩🇪",
      "currency_symbol": "€"
    },
    {
      "name": "Ghana",
      "dial_code": "+233",
      "code": "GH",
      "flag": "🇬🇭",
      "currency_symbol": "₵"
    },
    {
      "name": "Gibraltar",
      "dial_code": "+350",
      "code": "GI",
      "flag": "🇬🇮",
      "currency_symbol": "£"
    },
    {
      "name": "Greece",
      "dial_code": "+30",
      "code": "GR",
      "flag": "🇬🇷",
      "currency_symbol": "€"
    },
    {
      "name": "Greenland",
      "dial_code": "+299",
      "code": "GL",
      "flag": "🇬🇱",
      "currency_symbol": "kr."
    },
    {
      "name": "Grenada",
      "dial_code": "+1473",
      "code": "GD",
      "flag": "🇬🇩",
      "currency_symbol": "$"
    },
    {
      "name": "Guadeloupe",
      "dial_code": "+590",
      "code": "GP",
      "flag": "🇬🇵",
      "currency_symbol": "€"
    },
    {
      "name": "Guam",
      "dial_code": "+1671",
      "code": "GU",
      "flag": "🇬🇺",
      "currency_symbol": "$"
    },
    {
      "name": "Guatemala",
      "dial_code": "+502",
      "code": "GT",
      "flag": "🇬🇹",
      "currency_symbol": "Q"
    },
    {
      "name": "Guernsey",
      "dial_code": "+44",
      "code": "GG",
      "flag": "🇬🇬",
      "currency_symbol": "£"
    },
    {
      "name": "Guinea",
      "dial_code": "+224",
      "code": "GN",
      "flag": "🇬🇳",
      "currency_symbol": "Fr"
    },
    {
      "name": "Guinea-Bissau",
      "dial_code": "+245",
      "code": "GW",
      "flag": "🇬🇼",
      "currency_symbol": "Fr"
    },
    {
      "name": "Guyana",
      "dial_code": "+595",
      "code": "GY",
      "flag": "🇬🇾",
      "currency_symbol": "$"
    },
    {
      "name": "Haiti",
      "dial_code": "+509",
      "code": "HT",
      "flag": "🇭🇹",
      "currency_symbol": "G"
    },
    {
      "name": "Holy See (Vatican City State)",
      "dial_code": "+379",
      "code": "VA",
      "flag": "🇻🇦",
      "currency_symbol": "€"
    },
    {
      "name": "Honduras",
      "dial_code": "+504",
      "code": "HN",
      "flag": "🇭🇳",
      "currency_symbol": "L"
    },
    {
      "name": "Hong Kong",
      "dial_code": "+852",
      "code": "HK",
      "flag": "🇭🇰",
      "currency_symbol": "$"
    },
    {
      "name": "Hungary",
      "dial_code": "+36",
      "code": "HU",
      "flag": "🇭🇺",
      "currency_symbol": "Ft"
    },
    {
      "name": "Iceland",
      "dial_code": "+354",
      "code": "IS",
      "flag": "🇮🇸",
      "currency_symbol": "kr"
    },
    {
      "name": "India",
      "dial_code": "+91",
      "code": "IN",
      "flag": "🇮🇳",
      "currency_symbol": "₹"
    },
    {
      "name": "Indonesia",
      "dial_code": "+62",
      "code": "ID",
      "flag": "🇮🇩",
      "currency_symbol": "Rp"
    },
    {
      "name": "Iran, Islamic Republic of Persian Gulf",
      "dial_code": "+98",
      "code": "IR",
      "flag": "🇮🇷",
      "currency_symbol": "﷼"
    },
    {
      "name": "Iraq",
      "dial_code": "+964",
      "code": "IQ",
      "flag": "🇮🇶",
      "currency_symbol": "ع.د"
    },
    {
      "name": "Ireland",
      "dial_code": "+353",
      "code": "IE",
      "flag": "🇮🇪",
      "currency_symbol": "€"
    },
    {
      "name": "Isle of Man",
      "dial_code": "+44",
      "code": "IM",
      "flag": "🇮🇲",
      "currency_symbol": "£"
    },
    {
      "name": "Israel",
      "dial_code": "+972",
      "code": "IL",
      "flag": "🇮🇱",
      "currency_symbol": "₪"
    },
    {
      "name": "Italy",
      "dial_code": "+39",
      "code": "IT",
      "flag": "🇮🇹",
      "currency_symbol": "€"
    },
    {
      "name": "Jamaica",
      "dial_code": "+1876",
      "code": "JM",
      "flag": "🇯🇲",
      "currency_symbol": "$"
    },
    {
      "name": "Japan",
      "dial_code": "+81",
      "code": "JP",
      "flag": "🇯🇵",
      "currency_symbol": "¥"
    },
    {
      "name": "Jersey",
      "dial_code": "+44",
      "code": "JE",
      "flag": "🇯🇪",
      "currency_symbol": "£"
    },
    {
      "name": "Jordan",
      "dial_code": "+962",
      "code": "JO",
      "flag": "🇯🇴",
      "currency_symbol": "د.ا"
    },
    {
      "name": "Kazakhstan",
      "dial_code": "+77",
      "code": "KZ",
      "flag": "🇰🇿",
      "currency_symbol": "₸"
    },
    {
      "name": "Kenya",
      "dial_code": "+254",
      "code": "KE",
      "flag": "🇰🇪",
      "currency_symbol": "Sh"
    },
    {
      "name": "Kiribati",
      "dial_code": "+686",
      "code": "KI",
      "flag": "🇰🇮",
      "currency_symbol": "$"
    },
    {
      "name": "Korea, Democratic People's Republic of Korea",
      "dial_code": "+850",
      "code": "KP",
      "flag": "🇰🇵",
      "currency_symbol": "₩"
    },
    {
      "name": "Korea, Republic of South Korea",
      "dial_code": "+82",
      "code": "KR",
      "flag": "🇰🇷",
      "currency_symbol": "₩"
    },
    {
      "name": "Kuwait",
      "dial_code": "+965",
      "code": "KW",
      "flag": "🇰🇼",
      "currency_symbol": "د.ك"
    },
    {
      "name": "Kyrgyzstan",
      "dial_code": "+996",
      "code": "KG",
      "flag": "🇰🇬",
      "currency_symbol": "с"
    },
    {
      "name": "Laos",
      "dial_code": "+856",
      "code": "LA",
      "flag": "🇱🇦",
      "currency_symbol": "₭"
    },
    {
      "name": "Latvia",
      "dial_code": "+371",
      "code": "LV",
      "flag": "🇱🇻",
      "currency_symbol": "€"
    },
    {
      "name": "Lebanon",
      "dial_code": "+961",
      "code": "LB",
      "flag": "🇱🇧",
      "currency_symbol": "ل.ل"
    },
    {
      "name": "Lesotho",
      "dial_code": "+266",
      "code": "LS",
      "flag": "🇱🇸",
      "currency_symbol": "L"
    },
    {
      "name": "Liberia",
      "dial_code": "+231",
      "code": "LR",
      "flag": "🇱🇷",
      "currency_symbol": "$"
    },
    {
      "name": "Libyan Arab Jamahiriya",
      "dial_code": "+218",
      "code": "LY",
      "flag": "🇱🇾",
      "currency_symbol": "ل.د"
    },
    {
      "name": "Liechtenstein",
      "dial_code": "+423",
      "code": "LI",
      "flag": "🇱🇮",
      "currency_symbol": "Fr"
    },
    {
      "name": "Lithuania",
      "dial_code": "+370",
      "code": "LT",
      "flag": "🇱🇹",
      "currency_symbol": "€"
    },
    {
      "name": "Luxembourg",
      "dial_code": "+352",
      "code": "LU",
      "flag": "🇱🇺",
      "currency_symbol": "€"
    },
    {
      "name": "Macao",
      "dial_code": "+853",
      "code": "MO",
      "flag": "🇲🇴",
      "currency_symbol": "P"
    },
    {
      "name": "Macedonia",
      "dial_code": "+389",
      "code": "MK",
      "flag": "🇲🇰",
      "currency_symbol": "den"
    },
    {
      "name": "Madagascar",
      "dial_code": "+261",
      "code": "MG",
      "flag": "🇲🇬",
      "currency_symbol": "Ar"
    },
    {
      "name": "Malawi",
      "dial_code": "+265",
      "code": "MW",
      "flag": "🇲🇼",
      "currency_symbol": "MK"
    },
    {
      "name": "Malaysia",
      "dial_code": "+60",
      "code": "MY",
      "flag": "🇲🇾",
      "currency_symbol": "RM"
    },
    {
      "name": "Maldives",
      "dial_code": "+960",
      "code": "MV",
      "flag": "🇲🇻",
      "currency_symbol": ".ރ"
    },
    {
      "name": "Mali",
      "dial_code": "+223",
      "code": "ML",
      "flag": "🇲🇱",
      "currency_symbol": "Fr"
    },
    {
      "name": "Malta",
      "dial_code": "+356",
      "code": "MT",
      "flag": "🇲🇹",
      "currency_symbol": "€"
    },
    {
      "name": "Marshall Islands",
      "dial_code": "+692",
      "code": "MH",
      "flag": "🇲🇭",
      "currency_symbol": "$"
    },
    {
      "name": "Martinique",
      "dial_code": "+596",
      "code": "MQ",
      "flag": "🇲🇶",
      "currency_symbol": "€"
    },
    {
      "name": "Mauritania",
      "dial_code": "+222",
      "code": "MR",
      "flag": "🇲🇷",
      "currency_symbol": ""
    },
    {
      "name": "Mauritius",
      "dial_code": "+230",
      "code": "MU",
      "flag": "🇲🇺",
      "currency_symbol": "₨"
    },
    {
      "name": "Mayotte",
      "dial_code": "+262",
      "code": "YT",
      "flag": "🇾🇹",
      "currency_symbol": "€"
    },
    {
      "name": "Mexico",
      "dial_code": "+52",
      "code": "MX",
      "flag": "🇲🇽",
      "currency_symbol": "$"
    },
    {
      "name": "Micronesia, Federated States of Micronesia",
      "dial_code": "+691",
      "code": "FM",
      "flag": "🇫🇲",
      "currency_symbol": "$"
    },
    {
      "name": "Moldova",
      "dial_code": "+373",
      "code": "MD",
      "flag": "🇲🇩",
      "currency_symbol": "L"
    },
    {
      "name": "Monaco",
      "dial_code": "+377",
      "code": "MC",
      "flag": "🇲🇨",
      "currency_symbol": "€"
    },
    {
      "name": "Mongolia",
      "dial_code": "+976",
      "code": "MN",
      "flag": "🇲🇳",
      "currency_symbol": "₮"
    },
    {
      "name": "Montenegro",
      "dial_code": "+382",
      "code": "ME",
      "flag": "🇲🇪",
      "currency_symbol": "€"
    },
    {
      "name": "Montserrat",
      "dial_code": "+1664",
      "code": "MS",
      "flag": "🇲🇸",
      "currency_symbol": "$"
    },
    {
      "name": "Morocco",
      "dial_code": "+212",
      "code": "MA",
      "flag": "🇲🇦",
      "currency_symbol": "د.م."
    },
    {
      "name": "Mozambique",
      "dial_code": "+258",
      "code": "MZ",
      "flag": "🇲🇿",
      "currency_symbol": "MT"
    },
    {
      "name": "Myanmar",
      "dial_code": "+95",
      "code": "MM",
      "flag": "🇲🇲",
      "currency_symbol": "Ks"
    },
    {
      "name": "Namibia",
      "dial_code": "+264",
      "code": "NA",
      "flag": "🇳🇦",
      "currency_symbol": "$"
    },
    {
      "name": "Nauru",
      "dial_code": "+674",
      "code": "NR",
      "flag": "🇳🇷",
      "currency_symbol": "$"
    },
    {
      "name": "Nepal",
      "dial_code": "+977",
      "code": "NP",
      "flag": "🇳🇵",
      "currency_symbol": "₨"
    },
    {
      "name": "Netherlands",
      "dial_code": "+31",
      "code": "NL",
      "flag": "🇳🇱",
      "currency_symbol": "€"
    },
    {
      "name": "Netherlands Antilles",
      "dial_code": "+599",
      "code": "AN",
      "flag": "",
      "currency_symbol": ""
    },
    {
      "name": "New Caledonia",
      "dial_code": "+687",
      "code": "NC",
      "flag": "🇳🇨",
      "currency_symbol": "₣"
    },
    {
      "name": "New Zealand",
      "dial_code": "+64",
      "code": "NZ",
      "flag": "🇳🇿",
      "currency_symbol": "$"
    },
    {
      "name": "Nicaragua",
      "dial_code": "+505",
      "code": "NI",
      "flag": "🇳🇮",
      "currency_symbol": "C$"
    },
    {
      "name": "Niger",
      "dial_code": "+227",
      "code": "NE",
      "flag": "🇳🇪",
      "currency_symbol": "Fr"
    },
    {
      "name": "Nigeria",
      "dial_code": "+234",
      "code": "NG",
      "flag": "🇳🇬",
      "currency_symbol": "₦"
    },
    {
      "name": "Niue",
      "dial_code": "+683",
      "code": "NU",
      "flag": "🇳🇺",
      "currency_symbol": "$"
    },
    {
      "name": "Norfolk Island",
      "dial_code": "+672",
      "code": "NF",
      "flag": "🇳🇫",
      "currency_symbol": "$"
    },
    {
      "name": "Northern Mariana Islands",
      "dial_code": "+1670",
      "code": "MP",
      "flag": "🇲🇵",
      "currency_symbol": "$"
    },
    {
      "name": "Norway",
      "dial_code": "+47",
      "code": "NO",
      "flag": "🇳🇴",
      "currency_symbol": "kr"
    },
    {
      "name": "Oman",
      "dial_code": "+968",
      "code": "OM",
      "flag": "🇴🇲",
      "currency_symbol": "ر.ع."
    },
    {
      "name": "Pakistan",
      "dial_code": "+92",
      "code": "PK",
      "flag": "🇵🇰",
      "currency_symbol": "₨"
    },
    {
      "name": "Palau",
      "dial_code": "+680",
      "code": "PW",
      "flag": "🇵🇼",
      "currency_symbol": "$"
    },
    {
      "name": "Palestinian Territory, Occupied",
      "dial_code": "+970",
      "code": "PS",
      "flag": "🇵🇸",
      "currency_symbol": "₪"
    },
    {
      "name": "Panama",
      "dial_code": "+507",
      "code": "PA",
      "flag": "🇵🇦",
      "currency_symbol": "B/."
    },
    {
      "name": "Papua New Guinea",
      "dial_code": "+675",
      "code": "PG",
      "flag": "🇵🇬",
      "currency_symbol": "K"
    },
    {
      "name": "Paraguay",
      "dial_code": "+595",
      "code": "PY",
      "flag": "🇵🇾",
      "currency_symbol": "₲"
    },
    {
      "name": "Peru",
      "dial_code": "+51",
      "code": "PE",
      "flag": "🇵🇪",
      "currency_symbol": "S/ "
    },
    {
      "name": "Philippines",
      "dial_code": "+63",
      "code": "PH",
      "flag": "🇵🇭",
      "currency_symbol": "₱"
    },
    {
      "name": "Pitcairn",
      "dial_code": "+872",
      "code": "PN",
      "flag": "🇵🇳",
      "currency_symbol": "$"
    },
    {
      "name": "Poland",
      "dial_code": "+48",
      "code": "PL",
      "flag": "🇵🇱",
      "currency_symbol": "zł"
    },
    {
      "name": "Portugal",
      "dial_code": "+351",
      "code": "PT",
      "flag": "🇵🇹",
      "currency_symbol": "€"
    },
    {
      "name": "Puerto Rico",
      "dial_code": "+1939",
      "code": "PR",
      "flag": "🇵🇷",
      "currency_symbol": "$"
    },
    {
      "name": "Qatar",
      "dial_code": "+974",
      "code": "QA",
      "flag": "🇶🇦",
      "currency_symbol": "ر.ق"
    },
    {
      "name": "Romania",
      "dial_code": "+40",
      "code": "RO",
      "flag": "🇷🇴",
      "currency_symbol": "lei"
    },
    {
      "name": "Russia",
      "dial_code": "+7",
      "code": "RU",
      "flag": "🇷🇺",
      "currency_symbol": "₽"
    },
    {
      "name": "Rwanda",
      "dial_code": "+250",
      "code": "RW",
      "flag": "🇷🇼",
      "currency_symbol": "Fr"
    },
    {
      "name": "Reunion",
      "dial_code": "+262",
      "code": "RE",
      "flag": "🇷🇪",
      "currency_symbol": "€"
    },
    {
      "name": "Saint Barthelemy",
      "dial_code": "+590",
      "code": "BL",
      "flag": "🇧🇱",
      "currency_symbol": "€"
    },
    {
      "name": "Saint Helena, Ascension and Tristan Da Cunha",
      "dial_code": "+290",
      "code": "SH",
      "flag": "🇸🇭",
      "currency_symbol": "£"
    },
    {
      "name": "Saint Kitts and Nevis",
      "dial_code": "+1869",
      "code": "KN",
      "flag": "🇰🇳",
      "currency_symbol": "$"
    },
    {
      "name": "Saint Lucia",
      "dial_code": "+1758",
      "code": "LC",
      "flag": "🇱🇨",
      "currency_symbol": "$"
    },
    {
      "name": "Saint Martin",
      "dial_code": "+590",
      "code": "MF",
      "flag": "🇲🇫",
      "currency_symbol": "€"
    },
    {
      "name": "Saint Pierre and Miquelon",
      "dial_code": "+508",
      "code": "PM",
      "flag": "🇵🇲",
      "currency_symbol": "€"
    },
    {
      "name": "Saint Vincent and the Grenadines",
      "dial_code": "+1784",
      "code": "VC",
      "flag": "🇻🇨",
      "currency_symbol": "$"
    },
    {
      "name": "Samoa",
      "dial_code": "+685",
      "code": "WS",
      "flag": "🇼🇸",
      "currency_symbol": "T"
    },
    {
      "name": "San Marino",
      "dial_code": "+378",
      "code": "SM",
      "flag": "🇸🇲",
      "currency_symbol": "€"
    },
    {
      "name": "Sao Tome and Principe",
      "dial_code": "+239",
      "code": "ST",
      "flag": "🇸🇹",
      "currency_symbol": ""
    },
    {
      "name": "Saudi Arabia",
      "dial_code": "+966",
      "code": "SA",
      "flag": "🇸🇦",
      "currency_symbol": "ر.س"
    },
    {
      "name": "Senegal",
      "dial_code": "+221",
      "code": "SN",
      "flag": "🇸🇳",
      "currency_symbol": "Fr"
    },
    {
      "name": "Serbia",
      "dial_code": "+381",
      "code": "RS",
      "flag": "🇷🇸",
      "currency_symbol": "дин."
    },
    {
      "name": "Seychelles",
      "dial_code": "+248",
      "code": "SC",
      "flag": "🇸🇨",
      "currency_symbol": "₨"
    },
    {
      "name": "Sierra Leone",
      "dial_code": "+232",
      "code": "SL",
      "flag": "🇸🇱",
      "currency_symbol": "Le"
    },
    {
      "name": "Singapore",
      "dial_code": "+65",
      "code": "SG",
      "flag": "🇸🇬",
      "currency_symbol": "$"
    },
    {
      "name": "Slovakia",
      "dial_code": "+421",
      "code": "SK",
      "flag": "🇸🇰",
      "currency_symbol": "€"
    },
    {
      "name": "Slovenia",
      "dial_code": "+386",
      "code": "SI",
      "flag": "🇸🇮",
      "currency_symbol": "€"
    },
    {
      "name": "Solomon Islands",
      "dial_code": "+677",
      "code": "SB",
      "flag": "🇸🇧",
      "currency_symbol": "$"
    },
    {
      "name": "Somalia",
      "dial_code": "+252",
      "code": "SO",
      "flag": "🇸🇴",
      "currency_symbol": "Sh"
    },
    {
      "name": "South Africa",
      "dial_code": "+27",
      "code": "ZA",
      "flag": "🇿🇦",
      "currency_symbol": "R"
    },
    {
      "name": "South Sudan",
      "dial_code": "+211",
      "code": "SS",
      "flag": "🇸🇸",
      "currency_symbol": "£"
    },
    {
      "name": "South Georgia and the South Sandwich Islands",
      "dial_code": "+500",
      "code": "GS",
      "flag": "🇬🇸",
      "currency_symbol": ""
    },
    {
      "name": "Spain",
      "dial_code": "+34",
      "code": "ES",
      "flag": "🇪🇸",
      "currency_symbol": "€"
    },
    {
      "name": "Sri Lanka",
      "dial_code": "+94",
      "code": "LK",
      "flag": "🇱🇰",
      "currency_symbol": "Rs  රු"
    },
    {
      "name": "Sudan",
      "dial_code": "+249",
      "code": "SD",
      "flag": "🇸🇩",
      "currency_symbol": ""
    },
    {
      "name": "Suriname",
      "dial_code": "+597",
      "code": "SR",
      "flag": "🇸🇷",
      "currency_symbol": "$"
    },
    {
      "name": "Svalbard and Jan Mayen",
      "dial_code": "+47",
      "code": "SJ",
      "flag": "🇸🇯",
      "currency_symbol": "kr"
    },
    {
      "name": "Swaziland",
      "dial_code": "+268",
      "code": "SZ",
      "flag": "🇸🇿",
      "currency_symbol": "L"
    },
    {
      "name": "Sweden",
      "dial_code": "+46",
      "code": "SE",
      "flag": "🇸🇪",
      "currency_symbol": "kr"
    },
    {
      "name": "Switzerland",
      "dial_code": "+41",
      "code": "CH",
      "flag": "🇨🇭",
      "currency_symbol": "Fr."
    },
    {
      "name": "Syrian Arab Republic",
      "dial_code": "+963",
      "code": "SY",
      "flag": "🇸🇾",
      "currency_symbol": "£"
    },
    {
      "name": "Taiwan",
      "dial_code": "+886",
      "code": "TW",
      "flag": "🇹🇼",
      "currency_symbol": "$"
    },
    {
      "name": "Tajikistan",
      "dial_code": "+992",
      "code": "TJ",
      "flag": "🇹🇯",
      "currency_symbol": "ЅМ"
    },
    {
      "name": "Tanzania, United Republic of Tanzania",
      "dial_code": "+255",
      "code": "TZ",
      "flag": "🇹🇿",
      "currency_symbol": "Sh"
    },
    {
      "name": "Thailand",
      "dial_code": "+66",
      "code": "TH",
      "flag": "🇹🇭",
      "currency_symbol": "฿"
    },
    {
      "name": "Timor-Leste",
      "dial_code": "+670",
      "code": "TL",
      "flag": "🇹🇱",
      "currency_symbol": "$"
    },
    {
      "name": "Togo",
      "dial_code": "+228",
      "code": "TG",
      "flag": "🇹🇬",
      "currency_symbol": "Fr"
    },
    {
      "name": "Tokelau",
      "dial_code": "+690",
      "code": "TK",
      "flag": "🇹🇰",
      "currency_symbol": "$"
    },
    {
      "name": "Tonga",
      "dial_code": "+676",
      "code": "TO",
      "flag": "🇹🇴",
      "currency_symbol": "T$"
    },
    {
      "name": "Trinidad and Tobago",
      "dial_code": "+1868",
      "code": "TT",
      "flag": "🇹🇹",
      "currency_symbol": "$"
    },
    {
      "name": "Tunisia",
      "dial_code": "+216",
      "code": "TN",
      "flag": "🇹🇳",
      "currency_symbol": "د.ت"
    },
    {
      "name": "Turkey",
      "dial_code": "+90",
      "code": "TR",
      "flag": "🇹🇷",
      "currency_symbol": "₺"
    },
    {
      "name": "Turkmenistan",
      "dial_code": "+993",
      "code": "TM",
      "flag": "🇹🇲",
      "currency_symbol": "m"
    },
    {
      "name": "Turks and Caicos Islands",
      "dial_code": "+1649",
      "code": "TC",
      "flag": "🇹🇨",
      "currency_symbol": "$"
    },
    {
      "name": "Tuvalu",
      "dial_code": "+688",
      "code": "TV",
      "flag": "🇹🇻",
      "currency_symbol": "$"
    },
    {
      "name": "Uganda",
      "dial_code": "+256",
      "code": "UG",
      "flag": "🇺🇬",
      "currency_symbol": "Sh"
    },
    {
      "name": "Ukraine",
      "dial_code": "+380",
      "code": "UA",
      "flag": "🇺🇦",
      "currency_symbol": "₴"
    },
    {
      "name": "United Arab Emirates",
      "dial_code": "+971",
      "code": "AE",
      "flag": "🇦🇪",
      "currency_symbol": "د.إ"
    },
    {
      "name": "United Kingdom",
      "dial_code": "+44",
      "code": "GB",
      "flag": "🇬🇧",
      "currency_symbol": "£"
    },
    {
      "name": "United States",
      "dial_code": "+1",
      "code": "US",
      "flag": "🇺🇸",
      "currency_symbol": "$"
    },
    {
      "name": "Uruguay",
      "dial_code": "+598",
      "code": "UY",
      "flag": "🇺🇾",
      "currency_symbol": "$"
    },
    {
      "name": "Uzbekistan",
      "dial_code": "+998",
      "code": "UZ",
      "flag": "🇺🇿",
      "currency_symbol": "so'm"
    },
    {
      "name": "Vanuatu",
      "dial_code": "+678",
      "code": "VU",
      "flag": "🇻🇺",
      "currency_symbol": "Vt"
    },
    {
      "name": "Venezuela, Bolivarian Republic of Venezuela",
      "dial_code": "+58",
      "code": "VE",
      "flag": "🇻🇪",
      "currency_symbol": ""
    },
    {
      "name": "Vietnam",
      "dial_code": "+84",
      "code": "VN",
      "flag": "🇻🇳",
      "currency_symbol": "₫"
    },
    {
      "name": "Virgin Islands, British",
      "dial_code": "+1284",
      "code": "VG",
      "flag": "🇻🇬",
      "currency_symbol": "$"
    },
    {
      "name": "Virgin Islands, U.S.",
      "dial_code": "+1340",
      "code": "VI",
      "flag": "🇻🇮",
      "currency_symbol": "$"
    },
    {
      "name": "Wallis and Futuna",
      "dial_code": "+681",
      "code": "WF",
      "flag": "🇼🇫",
      "currency_symbol": "₣"
    },
    {
      "name": "Yemen",
      "dial_code": "+967",
      "code": "YE",
      "flag": "🇾🇪",
      "currency_symbol": "﷼"
    },
    {
      "name": "Zambia",
      "dial_code": "+260",
      "code": "ZM",
      "flag": "🇿🇲",
      "currency_symbol": "ZK"
    },
    {
      "name": "Zimbabwe",
      "dial_code": "+263",
      "code": "ZW",
      "flag": "🇿🇼",
      "currency_symbol": "$"
    }
];